import InstagramShareButton from './InstagramShareButton'

export default InstagramShareButton
